import { formatDate } from '@fullcalendar/core'

const classDates = [
	'08-29',
	'08-31',
	'09-02',
	'09-05',
	'09-07',
	'09-09',
	'09-12',
	'09-14',
	'09-16',
	// '09-19',  Was sick so cnacelled two classes, took out a Clarity and a Testimony
	// '09-21',
	'09-23',
	'09-26',
	'09-28',
	'09-30',
	'10-03',
	'10-05',
	'10-07',
	'10-12',
	'10-14',
	'10-17',
	'10-19',
	'10-21',
	'10-24',
	'10-26',
	'10-28',
	'10-31',
	'11-02',
	'11-04',
	'11-07',
	'11-09',
	'11-11',
	'11-14',
	'11-16',
	'11-18',
	'11-21',
	'11-28',
	'11-30',
	'12-02',
	'12-05',
	'12-07',
	'12-09'
].map(x=>'2022-'+x);

const examPeriod = [
	'12-12',
	'12-13',
	'12-14',
	'12-15',
	'12-16'
].map(x=>'2022-'+x);

const breakDays = [
	'10-08',
	'10-09',
	'10-10',
	'10-11',
	'11-23',
	'11-24',
	'11-25',
	'11-26',
	'11-27'
].map(x=>'2022-'+x);

const problemSetsAssigned = [
	'09-20', //after first Clarity class
	'10-13',   //after first Applications class
	'11-08',  // after first Updating class
	'12-10'  // after final class
].map(x=>'2022-'+x);

const problemSetsDue = [
	'09-24',  // five days later
	'10-17',
	'11-12',
	'12-15'
].map(x=>'2022-'+x+'T17:00');

// const readingQuestionsDue = [
// 	'01-22',  // beginning of most sections (could automate?)
// 	'01-29',
// 	'02-05',
// 	'02-19',
// 	'02-26',
// 	'03-12',
// 	'03-19',
// 	'03-29',
// 	'04-09',
// 	'04-16',
// 	'04-30'
// ].map(x=>'2022-'+x+'T23:59');

const modules = [
	{title: "Introduction", modNum: null, numClass: 2, readings: ["Aronson and Tavris, 'The Role of Cognitive Dissonance in the Pandemic'", "Rovelli, 'Statistical Illiteracy Isn’t a Niche Problem'"]},
	{title: "Reasoning", modNum: 1, numClass: 3, readings: "Manley, Chapter 1"},
	{title: "Mindset", modNum: 2, numClass: 3, readings: "Manley, Chapter 2"},
	{title: "Clarity", modNum: 3, numClass: 3, readings: ["Manley, Chapter 3", "Reading on Grice"]},
	{title: "Entailment", modNum: 4, numClass: 3, readings: "Manley, Chapter 4"},
	{title: "Evidence", modNum: 5, numClass: 3, readings: "Manley, Chapter 5"},
	{title: "Testimony", modNum: "Interlude", numClass: 4, readings: ["Nguyen", "Rini", "Cassam", "Medical", "Etc."]},
	{title: "Generalizing", modNum: 6, numClass: 3, readings: ["Manley, Chapter 6", "Weisberg, 19.1 and 19.2"]},
	{title: "Causes", modNum: 7, numClass: 3, readings: "Manley, Chapter 7"},
	{title: "Updating", modNum: 8, numClass: 5, readings: ["Manley, Chapter 2", "Weisberg, Chapter 1"]},
	{title: "Theories", modNum: 9, numClass: 3, readings: ["Manley, Chapter 2", "Weisberg, Chapter 4"]},
	{title: "Decisions", modNum: 10, numClass: 5, readings: "Manley, Chapter 10"}
]

const buildModuleDates = () => {
	let currClass = 0;
	const moduleDates = [];
	for (let i=0; i<modules.length; i++) {
		for (let j=0; j<modules[i].numClass; j++) {
			moduleDates.push({
				...modules[i], 
				start: classDates[currClass]
			})
			currClass++;
		}
	}
	return moduleDates;
}

const moduleEvents = buildModuleDates();
const moduleStartDates = buildModuleDates().filter((x,i)=>(x.title!=="Introduction"&&x.title!==moduleEvents[i-1].title))
//const moduleStartDates = buildModuleDates().filter((x,i)=>(x.title!=="Introduction"&&x.title!==moduleEvents[i-1].title)).filter(x=>(x.title!=="Applications")).filter(x=>(x.title!=="Reasoning"))
moduleStartDates.forEach(x=>x.title="Reading questions due")
//moduleStartDates.push({title: "Reading questions due", start: "2021-03-12"})
//moduleStartDates.push({title: "Reading questions due", start: "2022-09-05"})
//moduleStartDates.push({title: "Reading questions due", start: "2022-10-21"})
const problemSetEvents = problemSetsAssigned.map((x,i)=>({title:`Problem Set ${i+1} Available`, start: x, end: problemSetsDue[i]}))
const breakDayEvents = breakDays.map((x,i)=>({title:"Break Day", start: x}));
const examEvents = examPeriod.map((x,i)=>({title:"Exams", start: x}));

export { moduleEvents, problemSetEvents, breakDayEvents, problemSetsAssigned, problemSetsDue, examEvents, moduleStartDates };